import { useNavigate } from "react-router-dom";
import StyledButton from "../../UI/StyledButton";

const FinalPopUp = ({ message }: { message: string }) => {
  const navigate = useNavigate();

  function onFinal() {
    window.scrollTo(0, 0);
    navigate("/modules");
  }

  return (
    <div className="popUp">
      <div className="popFinalTest">
        <h3>{message}</h3>
        <StyledButton text="ДАЛЕЕ" onClick={onFinal} />
      </div>
    </div>
  );
};

export default FinalPopUp;
